/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 17:27:56
 * @LastEditors: linxi
 * @LastEditTime: 2022-09-23 09:41:50
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Popconfirm,
  Row,
} from 'antd'
import styles from './Tenants.module.css'
import _, { concat } from 'lodash'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationType } from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import { Label } from '../../compnents/widgets/Label'
import {
  setAppShadeIsModal,
  setAppShadeTipText,
} from '../../layouts/layoutSlice'
import { ThemeContext } from '../../theme/ThemeContext'
import { getMenuList, selectMenus } from '../grant/grantSlice'
import { getVolumeGrantMenus } from './tenantSlice'

export const VolumeSettingGrantModal = (props: {
  visible: boolean
  tenantIds: any
  num: any
  type: ApplicationType
  userId?: string
  onCancel: () => void
  onOk: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const menus = useSelector(selectMenus)

  const tenantIds = props?.tenantIds

  const class1Menus = menus.filter((m) => m.subMenus.length === 0)

  const class2Menus = menus.filter((m) => m.subMenus.length > 0)

  const spanCount = props?.type === ApplicationType.Management ? 4 : 6

  const [selectedKeys, setSelectedKeys] = useState<any>([])

  const allSelected =
    class1Menus.length == 0
      ? false
      : class1Menus.reduce((b, m) => b && selectedKeys.includes(m.id), true)

  console.log(selectedKeys, '111')

  const anySelected =
    class1Menus.length == 0
      ? false
      : class1Menus.reduce((b, m) => b || selectedKeys.includes(m.id), false)

  useEffect(() => {
    if (!props?.visible) {
      setSelectedKeys([])
    }
  }, [props?.visible])

  useEffect(() => {
    if (props?.visible) {
      dispatch(getMenuList(props?.type, props?.userId ? '用户' : '机构管理'))
    }
  }, [dispatch, props?.visible, props?.type, props?.userId])

  const grant = (ids: any, parentId: string, selected: boolean) => {
    if (selected) {
      const menuIds = _.chain(selectedKeys)
        .concat(ids)
        .concat(parentId)
        .filter((id) => !!id && id !== '-1')
        .uniq()
        .value()
      setSelectedKeys(menuIds?.flat())
    } else {
      let menuIds = _.chain(selectedKeys).difference(ids).value()
      const parent = class2Menus.find((m) => m.id === parentId)
      if (parent) {
        const noChild = parent.subMenus.reduce(
          (b, m) => b && !menuIds.includes(m.id),
          true
        )

        if (noChild) {
          menuIds = menuIds.filter((id) => id !== parentId)
        }
      }
      setSelectedKeys(menuIds?.flat())
    }
  }

  return (
    <div>
      <Modal
        footer={null}
        width={1000}
        className={styles.settingGrant}
        title={'批量设置' + `${props?.num}` + '家机构的功能权限'}
        visible={props.visible}
        onCancel={() => props.onCancel()}
        onOk={() => {
          props.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(fs) => {
            const menuIds = selectedKeys?.flat()
            dispatch(setAppShadeIsModal(true))
            dispatch(setAppShadeTipText('正在处理中，请稍后~~~'))
            dispatch(getVolumeGrantMenus({ menuIds, tenantIds }))
              .then(unwrapResult)
              .then(() => {
                dispatch(setAppShadeIsModal(false))
                dispatch(setAppShadeTipText('请稍后~~~'))
                props?.onOk()
                notification?.success({
                  message: '操作成功',
                  duration: 3,
                })
              })
              .catch(() => {
                dispatch(setAppShadeIsModal(false))
                dispatch(setAppShadeTipText('请稍后~~~'))
                props?.onOk()
                notification?.success({
                  message: '操作失败',
                  duration: 3,
                })
              })
          }}
        >
          <div style={{ height: '100%' }}>
            <div
              style={{
                borderRadius: 10,
                height: 'calc(100% - 70px)',
                backgroundColor: theme.pn,
                overflow: 'auto',
                padding: '20px',
              }}
            >
              <Label label='勾选需要开通的权限' />
              <Row
                style={{
                  marginTop: 20,
                  padding: '20px 20px 0 20px',
                  backgroundColor: theme.c3,
                }}
              >
                <Col span={spanCount}>
                  <Checkbox
                    style={{
                      color: theme.tc1,
                      fontSize: '1.125rem',
                      marginBottom: 18,
                    }}
                    indeterminate={!allSelected && anySelected}
                    checked={allSelected}
                    onChange={(e) => {
                      grant(
                        class1Menus.map((m) => m.id),
                        '',
                        e.target.checked
                      )
                    }}
                  >
                    全选
                  </Checkbox>
                </Col>
                {class1Menus.map((m) => (
                  <Col key={m.id} span={spanCount}>
                    <Checkbox
                      style={{
                        color: theme.tc1,
                        fontSize: '1.125rem',
                        marginBottom: 18,
                      }}
                      checked={selectedKeys.includes(m.id)}
                      onChange={(e) => {
                        grant([m.id], m.parentId, e.target.checked)
                      }}
                    >
                      {m.name}
                    </Checkbox>
                  </Col>
                ))}
              </Row>
              {class2Menus.map((p) => {
                const allSubmenuSelected = p.subMenus.reduce(
                  (b, m) => b && selectedKeys.includes(m.id),
                  true
                )
                const anySubmenuSelected = p.subMenus.reduce(
                  (b, m) => b || selectedKeys.includes(m.id),
                  false
                )
                return (
                  <div key={p.id}>
                    <Row
                      align='middle'
                      style={{
                        height: '3rem',
                        backgroundColor: theme.c3,
                        marginTop: 12,
                        padding: '0 20px',
                      }}
                    >
                      <Checkbox
                        style={{ fontSize: '1.125rem', color: theme.tc1 }}
                        indeterminate={
                          !allSubmenuSelected && anySubmenuSelected
                        }
                        checked={allSubmenuSelected}
                        onChange={(e) => {
                          grant(
                            p.subMenus.map((m) => m.id),
                            p.id,
                            e.target.checked
                          )
                        }}
                      >
                        {p.name}
                      </Checkbox>
                    </Row>
                    <Row
                      style={{
                        border: `1px solid ${theme.wbd}`,
                        borderTop: 'none',
                        padding: '0 48px 15px 48px',
                      }}
                    >
                      {p.subMenus.map((m) => (
                        <Col key={m.id} span={spanCount}>
                          <Checkbox
                            style={{
                              fontSize: '1.125rem',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              color: theme.tc2,
                              marginTop: 15,
                              whiteSpace: 'nowrap',
                            }}
                            checked={selectedKeys.includes(m.id)}
                            onChange={(e) =>
                              grant([m.id], m.parentId, e.target.checked)
                            }
                          >
                            {m.name}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )
              })}
            </div>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
                margin: '20px 0px 0 0 ',
                paddingTop: '15px',
                borderTop: '1px solid #f0f0f0',
              }}
            >
              <div
                style={{
                  height: '50px',
                  marginRight: '10px',
                }}
              >
                <Button
                  onClick={() => {
                    props.onCancel()
                    form.resetFields()
                  }}
                >
                  取消
                </Button>
              </div>
              <div
                style={{
                  height: '50px',
                  marginRight: '10px',
                }}
              >
                <Popconfirm
                  placement='topRight'
                  title={
                    '本次操作将会覆盖 ' +
                    `${props?.num}` +
                    ' 家机构原来的功能权限，请确认！'
                  }
                  onConfirm={() => {
                    form.submit()
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <Button type='primary'>确认</Button>
                </Popconfirm>
              </div>
            </Row>
          </div>
        </Form>
      </Modal>
    </div>
  )
}
